import { Vehicle } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicle';
import { VehicleConfiguration } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/vehicleconfiguration';
import { CustomiseOptions } from 'interface';

export function useInitialOptions(
  vehicleDetails: Vehicle,
  finalisedOptions: CustomiseOptions
) {
  let emptyFinalisedOptions = Object.values(finalisedOptions).every(
    (property) =>
      Object.values(property).every((value: any) => value.length === 0)
  );

  const { colours, options } = (vehicleDetails as Vehicle)
    .customisationOptions as VehicleConfiguration;

  let syncedOptions: CustomiseOptions;

  if (!emptyFinalisedOptions) {
    syncedOptions = finalisedOptions;
  } else {
    syncedOptions = {
      colours: colours,
      options: options,
    };
  }

  return syncedOptions;
}
